/**
 * @private
 */
export class TextSearchResult {
    constructor(owner) {
        this.startIn = undefined;
        this.endIn = undefined;
        this.startOffset = undefined;
        this.endOffset = undefined;
        this.owner = owner;
        this.documentHelper = this.owner.documentHelper;
    }
    get start() {
        return this.startIn;
    }
    set start(value) {
        this.startIn = value;
    }
    get end() {
        return this.endIn;
    }
    set end(value) {
        this.endIn = value;
    }
    get text() {
        const startPosition = this.documentHelper.selection.getTextPosBasedOnLogicalIndex(this.startOffset);
        const endPosition = this.documentHelper.selection.getTextPosBasedOnLogicalIndex(this.endOffset);
        return this.documentHelper.selection.getTextInternal(startPosition, endPosition, false);
    }
    destroy() {
        this.start = undefined;
        this.end = undefined;
        this.startOffset = undefined;
        this.endOffset = undefined;
    }
}
